import AppLayout from "@components/layout/AppLayout"
import StockPricesTable from "@components/dataDisplay/stockPricesTable/StockPricesTable"
import { QuotesResponse } from "@ts/interfaces/quotesResponse.interface"

async function getServerSideProps() {
  const res = await fetch(
    `https://wp.fuw.ch/wp-json/fuw/v1/marketdata/quotes/121222008-1329-1,998089-4-1,846480-353-814,37504714-353-333,998032-830-814,998407-3127-534,897789-148-1,275000-148-1,2329321-3269-333,999999915312-9910014-333,274702-148-333,274207-2913-333`
  )
  const quotesResponse = await res.json()

  return { props: { quotesResponse } }
}

const StockPricesTablePage = ({ quotesResponse }: { quotesResponse: QuotesResponse }) => {
  return (
    <AppLayout title="Stock Prices Table" robots="noindex,nofollow">
      <StockPricesTable quotesResponse={quotesResponse} />
    </AppLayout>
  )
}

export { getServerSideProps }
export default StockPricesTablePage
